<script>
	import { onMount, onDestroy } from "svelte";
	let htmlInput = "";
	let cssInput = "";
	let classesToKeep = "";
	let outputCss = "";

	function extractClassNamesFromHtml(html) {
		const classNames = new Set();
		// Existing regex for static class names
		const staticRegex = /class=["']([^"']*)["']/gi;
		let match;

		while ((match = staticRegex.exec(html)) !== null) {
			match[1].split(/\s+/).forEach((className) => {
				if (className) classNames.add(className);
			});
		}

		// New regex for dynamic expressions within {}
		const dynamicRegex = /\{([^}]+)\}/g;
		while ((match = dynamicRegex.exec(html)) !== null) {
			// Simplistic parsing of ternary expressions for class names
			const potentialClasses = match[1].split(/[?:'"\s]+/);
			potentialClasses.forEach((className) => {
				if (className && /^[a-zA-Z0-9-_:\/\[\]]+$/.test(className)) {
					// A basic check for valid class names
					classNames.add(className);
				}
			});
		}

		return Array.from(classNames);
	}

	function extractCssRules(css) {
		// This regex aims to capture CSS rules, including selectors and their styles
		// Note: This is a simplified approach and might need adjustments for complex CSS
		const regex = /([^{]+){([^}]+)}/g;
		let match;
		const cssRules = [];

		while ((match = regex.exec(css)) !== null) {
			let selectors = match[1].trim().split(/\s*,\s*/); // Splitting multiple selectors
			let styles = match[2].trim();
			selectors.forEach((selector) => {
				// Normalize selector for comparison (e.g., handling special characters)
				const normalizedSelector = selector.replace(
					/\\\[|\[|\]|\\]/g,
					(match) => {
						// Handle specific normalization here if needed
						return match;
					},
				);
				cssRules.push({ selector: normalizedSelector, styles });
			});
		}

		return cssRules;
	}

	function refineCss() {
		let htmlClasses = extractClassNamesFromHtml(htmlInput).map(
			(className) => "." + className,
		);
		let cssRules = extractCssRules(cssInput);

		// Normalize HTML classes for comparison
		let normalizedHtmlClasses = new Set(htmlClasses);

		// Include additional classes specified by the user
		let additionalClassesFormatted = classesToKeep
			.split(" ")
			.map((className) => "." + className);
		additionalClassesFormatted.forEach((className) =>
			normalizedHtmlClasses.add(className),
		);

		// Filter CSS rules based on normalized selectors
		let filteredRules = cssRules.filter(({ selector, styles }) => {
			// Remove backslashes for comparison
			let normalizedSelector = selector.replace(/\\/g, "");

			return normalizedHtmlClasses.has(normalizedSelector);
		});

		// Reassemble the filtered CSS
		outputCss = filteredRules
			.map(({ selector, styles }) => `${selector}{${styles}}`)
			.join("");
	}

	//
	function onEnterKeypress() {
		refineCss();
	}

	onMount(() => {
		window.addEventListener("keydown", onEnterKeypress);
	});

	onDestroy(() => {
		window.removeEventListener("keydown", onEnterKeypress);
	});

	$: if (htmlInput !== "" && cssInput !== "") {
		onEnterKeypress();
	}
</script>

<textarea
	bind:value={htmlInput}
	class="htmlInput"
	placeholder="Paste your HTML here"
></textarea>
<textarea
	bind:value={cssInput}
	class="cssInput"
	placeholder="Paste your Tailwind CSS here"
></textarea>
<textarea
	bind:value={classesToKeep}
	placeholder="Specify classes to keep (separated by space)"
></textarea>
<button class="refineBtn" on:click={refineCss}>Refine CSS</button>
<textarea
	readonly
	class="outputCss"
	placeholder="Refined CSS will be displayed here">{outputCss}</textarea
>

<style>
	textarea {
		width: 100%;
		min-height: 100px;
		margin-bottom: 1rem;
	}
	button {
		padding: 0.5rem 1rem;
		background-color: #3490dc;
		color: white;
		border: none;
		border-radius: 0.25rem;
		cursor: pointer;
	}
</style>
